import { S } from "../styles";

export function CostCell({ cost }: { cost: string | null }) {
  if (!cost) return <span style={S.muted}>—</span>;
  const n = parseFloat(cost);
  return (
    <span style={{ fontVariantNumeric: "tabular-nums", fontSize: 13 }}>
      ${n < 0.01 ? n.toFixed(5) : n.toFixed(4)}
    </span>
  );
}
